module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-card-header"
  }, [_vm._t("avatar"), _vm._v(" "), (_vm.title || _vm.subTitle) ? _c('div', {
    staticClass: "mu-card-header-title"
  }, [_c('div', {
    staticClass: "mu-card-title",
    class: _vm.titleClass
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mu-card-sub-title",
    class: _vm.subTitleClass
  }, [_vm._v("\n      " + _vm._s(_vm.subTitle) + "\n    ")])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77e27ec0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/card/cardHeader.vue
// module id = 3793
// module chunks = 1